import styled from 'styled-components';

export default styled.div`
    grid-template-columns: repeat(1, 1fr);
    grid-auto-rows: 6.4rem;
    column-gap: 1.6rem;
    max-width: 100%;
    display: grid;

    > * {
        grid-column: span 1;
        grid-row: span 1;
    }

    @media (min-width: ${({ theme }) => theme.mediaQueries.xs}) {
        grid-template-columns: repeat(2, 1fr);
        row-gap: ${({ theme }) => theme.spacing['30_Small']};
    }

    @media screen and (min-width: ${({ theme }) => theme.mediaQueries.s}) {
        row-gap: 0;
    }

    @media (min-width: ${({ theme }) => theme.mediaQueries.m}) {
        gap: 3.2rem;
        grid-template-columns: repeat(6, 1fr);
        align-items: center;
        justify-content: center;
        grid-auto-rows: auto;

        > * {
            grid-row: span 2;
            grid-column: span 2;
        }

        > :nth-child(2n) {
            margin-top: 0;
            transform: translateY(0);
        }

        /* if there's only 1 child in the grid... */
        > :first-child:last-child {
            grid-column-start: 2;
            grid-column-end: 6;
            grid-row: span 3;
        }

        /* if there's only 2 children in the grid... */
        > :last-child:nth-child(2),
        > :nth-last-child(2):first-child {
            grid-column: span 3;
            grid-row: span 3;
        }

        /* in a 2 children grid, place the last child manually */
        > :last-child:nth-child(2) {
            grid-row-start: 2;
            grid-row-end: 5;
            grid-column-start: 4;
            grid-column-end: 7;
        }

        /* place first and 3rd child manually */
        > :first-child {
            grid-row-start: 2;
            grid-row-end: 4;
            grid-column-start: 1;
            grid-column-end: 3;
        }
        > :nth-child(3) {
            grid-row-start: 2;
            grid-row-end: 4;
            grid-column-start: 5;
            grid-column-end: 7;
        }
    }
`;
